// Links that log in, create or claim an account: magic links (restored accounts
// also arrive as one), invite links and the signup page they lead to. Acting on
// one while logged in would replace or wipe the current session.
const ACCOUNT_LINK_PATH = /^\/(magic|inv|signup)\/[^/?#]+/;

export function isAccountLinkPath(path: string): boolean {
  return ACCOUNT_LINK_PATH.test(path);
}

const LAST_ACCOUNT_LINK_KEY = 'lastAccountLink';

// Android hands the app the link that launched it again whenever it restores the
// app after killing it, and a link can arrive through more than one plugin. So
// each link is answered once; kept outside redux-persist so logout keeps it.
export function isNewAccountLink(path: string): boolean {
  try {
    if (window.localStorage.getItem(LAST_ACCOUNT_LINK_KEY) === path) {
      return false;
    }
    window.localStorage.setItem(LAST_ACCOUNT_LINK_KEY, path);
  } catch (error) {
    // Without storage every link counts as new.
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/router/accountLinks.ts